import { string } from '@philips-emr/tws-core/lib/component/prop-types';
import { Formatter, registerFormatter } from '@philips-emr/tws-core/lib/services/model-service';

interface OverflowFormatterOptions {
  limit?: string,
  moreSymbol?: string,
}

function format(value: string, options: OverflowFormatterOptions = {}): string {
  const { limit = '32', moreSymbol = '...' } = options;
  const numberLimit = Number(limit);

  return value ? value.length < numberLimit && value || `${value.substr(0, numberLimit)}${moreSymbol}` : '';
}

format.optionTypes = {
  limit: string,
  moreSymbol: string,
};

format.defaultOptions = {
  limit: 32,
  moreSymbol: '...',
};

const formatterFunctions: Formatter<string, OverflowFormatterOptions> = {
  format,
  parse: () => '',
  validate: () => [],
  getPattern: () => '',
};

registerFormatter('overflow', formatterFunctions);

export default registerFormatter;
